import { TouchableOpacity, Text } from "react-native";

interface Props {
  onRemoveImage: () => void;
}

export function RemoveImageButton({ onRemoveImage }: Props) {
  return (
    <TouchableOpacity
      onPress={onRemoveImage}
      className="mt-2 w-36 h-10 bg-secondary-0 rounded-md items-center justify-center"
    >
      <Text className="text-primary-600">Remove photo</Text>
    </TouchableOpacity>
  );
}
